import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

export function About(props) {
    const [ChooseSlide, setChooseSlide] = useState(1);
    const [HideClass, setHideClass] = useState('');
    const TextTranslate = {
        titlefirst: {
            ru: 'Мы создаем умные технологии',
            en: 'We create smart technologies'
        },
        descfirst: {
            ru: 'Каждый день мы работаем над разработкой и внедрением самых передовых и инновационных технологий в повседневную жизнь людей',
            en: 'Every day we work on the development and implementation of the most advanced and innovative technologies in the daily life of people'
        },
        titlesecond: {
            ru: 'Наши решения созданы вокруг клиента',
            en: 'Our solutions are created around the client'
        },
        descsecond: {
            ru: 'Как компания, ориентированная на клиента, мы начинаем с понимания стратегических потребностей наших клиентов, а затем предлагаем подходящий продукт. Бесконтактная система авторизации, процессинговая система нового поколения, корпоративный мессенджер, медиа платформа – далеко не весь список наших решений',
            en: 'As a client-centric company, we start by understanding our customers’ strategic needs, then recommend a suitable product. Once we figured out a problem, we offer a solution. A contactless authorization system, a new generation processing system, a corporate messenger, a media platform - not the whole list of our solutions'
        },
        button_solutions: {
            ru: 'РЕШЕНИЯ',
            en: 'SOLUTIONS'
        },
        button_about_company: {
            ru: 'О КОМПАНИИ',
            en: 'ABOUT COMPANY'
        }
    };
    useEffect(() => {setHideClass('')}, [ChooseSlide])
    useEffect(() => {
        const interval = setInterval(function () {
            if(ChooseSlide === 1){
                setHideClass('hide');
                setTimeout(function () {setChooseSlide(2)}, 500)
                // setChooseSlide(2);
            }
            else{
                setHideClass('hide');
                setTimeout(function () {setChooseSlide(1)}, 500)
                // setChooseSlide(1);
            }
        }, 12000)
        return () => clearInterval(interval)
    })

    return (
        <div className={'about-main'}>
            {ChooseSlide === 1 ? <>
                <div className={'about-main-block'}>
                    <p className={'about-main-header'}>
                        {TextTranslate.titlefirst[props.Lang]}
                    </p>
                    <p className={'about-main-text'}>
                        {TextTranslate.descfirst[props.Lang]}
                    </p>
                    <Link to={'/aboutcompany'}>
                        <div className={'button-about'}>
                            <span className={'span-button'}>{TextTranslate.button_about_company[props.Lang]}</span>
                        </div>
                        {/*<img src={props.Lang === 'ru' ? "././BUTTON_about_comp.svg" : "./BUTTON_about_compEN.svg"}/>*/}
                    </Link>
                    <p className={'sliders-boxes'}>
                        <div className={'slide-box-item active-slide-box-item'} onClick={() => {setChooseSlide(1)}}></div>
                        <div className={'slide-box-item'} onClick={() => {setHideClass('hide'); setTimeout(function () {setChooseSlide(2)}, 500)}} ></div>
                    </p>
                </div>
                <div className={'img-about-block ' + HideClass}>
                    <img className={'img_about_page'} src={"./overcom_site_company_w_alpha11.png"}/>
                </div>
            </> : <>
                <div className={'about-main-block'}>
                    <p className={'about-main-header'}>
                        {TextTranslate.titlesecond[props.Lang]}
                    </p>
                    <p className={'about-main-text'}>
                        {TextTranslate.descsecond[props.Lang]}
                    </p>
                    <Link to={'/solutions'}>
                        <div className={'button-about'}>
                            <span className={'span-button'}>{TextTranslate.button_solutions[props.Lang]}</span>
                        </div>
                        {/*<img src={props.Lang === 'ru' ? "./BUTTON_resheniya.svg" : "./BUTTON_resheniyaEN.svg"}/>*/}
                    </Link>
                    <p className={'sliders-boxes'}>
                        <div className={'slide-box-item'} onClick={() => {setHideClass('hide'); setTimeout(function (){setChooseSlide(1)}, 500)}}></div>
                        <div className={'slide-box-item active-slide-box-item'} onClick={() => {setChooseSlide(2)}}></div>
                    </p>
                </div>
                <div className={'img-about-block ' + HideClass}>
                    <img className={'img_about_page'} src={"./overcom_site_products_w_alpha11.png"}/>
                </div>
            </>
            }
        </div>
    );
}
